/** Fixed dimension tokens for controls, avatars, and layout constraints */
export const size = {
  icon: {
    xs: 16,
    sm: 20,
    md: 24,
    lg: 36,
    xl: 48,
  },
  avatar: {
    sm: 24,
    md: 32,
    lg: 40,
    xl: 56,
  },
  control: {
    sm: 32,
    md: 40,
    lg: 48,
  },
  touchTarget: {
    min: 44,
  },
  width: {
    xs: 320,
    sm: 480,
    md: 640,
    lg: 960,
    full: "100%",
  },
  height: {
    xs: 200,
    sm: 320,
    md: 480,
    lg: 640,
    full: "100%",
  },
  aspectRatio: {
    square: "1 / 1",
    video: "16 / 9",
    portrait: "3 / 4",
    wide: "21 / 9",
  },
} as const;

export type TSize = typeof size;
